import { RequestConfig } from '~/common/services/requests';
import { InceptHeader } from '../../../../../api';
import { Module } from '../../../../../constants';
import { AccessToken, Nullable, TwoFactorToken } from '../../../../../types';

export const getAuthConfig = (
  config: RequestConfig,
  accessToken: Nullable<AccessToken>,
  twoFactorToken: Nullable<TwoFactorToken>,
  module: Module,
): RequestConfig => {
  const headers = { ...config.headers };

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  // The module context is authoritative and always sent (including on login,
  // where it tells the backend which module to mint the token for). It comes
  // from the current module, not the token, so a stale token can never set the
  // wrong context.
  headers[InceptHeader.Context] = module;

  if (twoFactorToken) {
    headers[InceptHeader.TwoFactorToken] = twoFactorToken;
  }

  return { ...config, headers };
};
